import React from "react";
import { Button } from "@material-ui/core";
import { GetApp } from "@material-ui/icons";
import clsx from "clsx";

// Componentes modernos de mídia
import { ImageMedia, VideoMedia, AudioMedia, ContactMedia } from "./MediaComponents";
import WhatsAppAudioPlayer from "./WhatsAppAudioPlayer";

// Constantes e Utilitários
import { MESSAGE_MEDIA_TYPES, LAYOUT_CONFIG } from "../constants/messageConstants";
import { truncateQuotedText } from "../utils/messageFormatters";

/**
 * 🎭 Componente QuotedMessage
 * 
 * Renderiza uma mensagem citada dentro de outra mensagem.
 * Suporta diferentes tipos de mídia e truncamento de texto.
 * 
 * @param {Object} message - Mensagem principal que contém a citação
 * @param {Object} classes - Classes de estilo do Material-UI
 */
const QuotedMessage = ({ message, classes }) => {
  const quotedText = message.quotedMsg?.body || "";
  const { displayText, isTruncated } = truncateQuotedText(quotedText, LAYOUT_CONFIG.QUOTED_MESSAGE_MAX_LENGTH);

  // Se não há mensagem citada, não renderiza nada
  if (!message.quotedMsg) {
    return null;
  }
  return (
    <div
      className={clsx(classes.quotedContainerLeft, {
        [classes.quotedContainerRight]: message.fromMe,
      })}
      style={{
        // Garantia adicional de contenção
        maxWidth: "100%",
        minWidth: 0,
        overflow: "hidden",
      }}
    >
      <span
        className={clsx(classes.quotedSideColorLeft, {
          [classes.quotedSideColorRight]: message.quotedMsg?.fromMe,
        })}
      ></span>
      
      <div className={classes.quotedMsg}>
        {/* Nome do contato (apenas para mensagens recebidas) */}
        {!message.quotedMsg?.fromMe && (
          <span className={classes.messageContactName}>
            {message.quotedMsg?.contact?.name}
          </span>
        )}        {/* Renderização por tipo de mídia - MODERNIZADA */}
        {message.quotedMsg.mediaType === MESSAGE_MEDIA_TYPES.AUDIO && (
          <div className={clsx(classes.downloadMedia, classes.quotedMediaContainer)}>
            <WhatsAppAudioPlayer message={message.quotedMsg} messageIndex={-1} />
          </div>
        )}

        {message.quotedMsg.mediaType === MESSAGE_MEDIA_TYPES.VIDEO && (
          <div className={classes.quotedMediaContainer}>
            <VideoMedia 
              message={message.quotedMsg}
              variant="quoted"
              size="small"
            />
          </div>
        )}

        {message.quotedMsg.mediaType === MESSAGE_MEDIA_TYPES.CONTACT && (
          <div className={classes.quotedMediaContainer}>
            <ContactMedia 
              message={message.quotedMsg}
              variant="quoted"
              size="small"
            />
          </div>
        )}

        {message.quotedMsg.mediaType === MESSAGE_MEDIA_TYPES.APPLICATION && (
          <div className={clsx(classes.downloadMedia, classes.quotedMediaContainer)}>
            <Button
              startIcon={<GetApp />}
              variant="outlined"
              target="_blank"
              href={message.quotedMsg.mediaUrl}
              className={classes.quotedDownloadButton}
            >
              Download
            </Button>
          </div>
        )}

        {/* Renderização de imagens - MODERNIZADA */}
        {message.quotedMsg.mediaType === MESSAGE_MEDIA_TYPES.IMAGE && (
          <div className={classes.quotedMediaContainer}>
            <ImageMedia 
              message={message.quotedMsg}
              variant="quoted"
              size="small"
            />
          </div>
        )}

        {/* Texto da mensagem citada - apenas se não for mídia visual ou se tiver texto junto com mídia */}
        {(message.quotedMsg.mediaType !== MESSAGE_MEDIA_TYPES.IMAGE && 
          message.quotedMsg.mediaType !== MESSAGE_MEDIA_TYPES.VIDEO && 
          message.quotedMsg.mediaType !== MESSAGE_MEDIA_TYPES.CONTACT &&
          message.quotedMsg.mediaType !== MESSAGE_MEDIA_TYPES.APPLICATION &&
          displayText.trim() !== '') && (
          <span>{displayText}</span>
        )}
      </div>
    </div>
  );
};

export default QuotedMessage;
